import React, {useState} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import styles from './ThirdPartyInfo.css';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import {Form} from '@deere/ux.uxframe-react';
import {getCurrentDdTimeStamp} from '../../DateTimeStamp';
import Divider from '@material-ui/core/Divider';
import {FormattedMessage, useIntl} from 'react-intl';
import {roleMap, errorMsgMap} from '../../../mappers/translationMappers';
import PropTypes from 'prop-types';


const inputStyles = {
    odSignerImputFieldError: {
        border: '1px solid',
        borderRadius: '6px',
        borderColor: '#c21020',
        maxWidth: '80%'
    },
    odSignerImputField: {
        border: '1px solid',
        borderRadius: '6px',
        marginBottom: '10px',
        borderColor: '#808080',
        maxWidth: '80%'
    }

};
AddNewSignerPopup.propTypes = {
    odName: PropTypes.string,
    odEmail: PropTypes.string,
    odContactNumber: PropTypes.string,
    showPopup: PropTypes.bool.isRequired,
    setShowPopup: PropTypes.func.isRequired,
    getOnDemandSigners: PropTypes.func.isRequired,
    isProxy: PropTypes.bool.isRequired,
    allRepresentators: PropTypes.array.isRequired,
    selectedThirdParty: PropTypes.object
};

export default function AddNewSignerPopup({
    defaultTPs,
    odName,
    odEmail,
    odContactNumber,
    showPopup,
    setShowPopup,
    getOnDemandSigners,
    isProxy,
    allRepresentators
 }){
    const [name, setName] = useState(odName);
    const [email, setEmail] = useState(odEmail);
    const [contactNumber, setContactNumber] = useState(odContactNumber);
    const [selectedThirdParty, setSelectedThirdParty] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const signerId = 'OD' + getCurrentDdTimeStamp(new Date());
    const signerRole = isProxy ? 'PROXY' : 'ON DEMAND';
    const intl = useIntl();

    const handleClose = () => {
        setShowPopup(false);
        setErrorMessage('');
    }

    function resetAll() {
        setName(odName);
        setEmail(odEmail);
        setContactNumber(odContactNumber);
        setSelectedThirdParty('');
        setErrorMessage('');
    }
    function handleThirdPartySelection(event) {
        const value = event.target.value;
        if (value) {
            const [, role] = value.split('-');
            const currentCount = allRepresentators.filter((party) => party.representativeFor === value).length;

            const limits = {
                PRIMARY: 6,      // Allow up to 6 selections for PRIMARY
                CO_BORROWER: 2,  // Allow up to 2 selections for CO-BORROWER
                DEALER: 2        // Allow up to 2 selections for DEALER
            };
            const roleName = intl.formatMessage({id: roleMap[role].props.id});
            const errorst1 =intl.formatMessage({id: errorMsgMap['you can only assign'].props.id});
            const errorst2 =intl.formatMessage({id: errorMsgMap['representatives to the'].props.id});
            if (currentCount >= limits[role]) {
                setErrorMessage(`${errorst1} ${limits[role]}  ${errorst2} ${roleName}`);
            } else {
                setSelectedThirdParty(value);
                setErrorMessage('');
            }
        }
    }

    function saveOnDemandSigner() {
        const odSigner = {
            'role': signerRole,
            'tpNumber': signerId,
            'name': name.trim(),
            'emailID': email.trim(),
            'phoneNumber': contactNumber,
            'icsID': null,
            'signer': true,
            'signingOrder': 1,
            'signingMethod': 'Sign by email',
            'representativeFor': isProxy ? selectedThirdParty : null
        }
        getOnDemandSigners(odSigner);
        resetAll();
        setShowPopup(false);
    }

    function saveAndAddNextOnDemandSigner() {
        saveOnDemandSigner();
        setShowPopup(true);
    }

    const filteredThirdParties = (defaultTPs || []).filter(thirdParty =>
        thirdParty.role !== 'GUARANTOR' && thirdParty.role !== 'ASSOCIATE' && thirdParty.thirdPartyClass !== 'Individual'
    );

    return (
        <Dialog aria-labelledby="add-signer-dialog" className={styles.addSignerDialog}
            fullWidth={true} onClose={handleClose}
            open={showPopup}>
            <div className={styles.signerDialogTitle}>
                <div>
                    <span className="form-dialog-title">
                        <FormattedMessage id={isProxy ? 'labels.ADD_NEW_PROXY' : 'labels.ADD_NEW_SIGNER'}/>
                    </span>
                    <div className={styles.signerId}>ID: {signerId}</div>
                </div>
                <IconButton aria-label="close" onClick={handleClose} size="small">
                    <CloseIcon fontSize="small"/>
                </IconButton>

            </div>
            <Divider/>
            <div className={styles.odSignerTop}>
                <AccountCircleIcon className={styles.odSignerAvatar} color="disabled"/>
                <div className={styles.signerRole}>

                    <FormattedMessage
                        id={'labels.ROLE'}/>: {isProxy ? roleMap['PROXY'] : roleMap[signerRole]}</div>
            </div>
            <div className={styles.odSignerDialogContent}>
                <Form.Group>
                    <p className={styles.odSignerInputLabel}>
                        <FormattedMessage id={'labels.NAME'}/>
                        <span
                            aria-label="required field"
                            className="uxf-is-required">*</span>
                    </p>
                    <Form.Control className="odSignerImputField"
                        data-sl="mask"
                        id="odSignerName"
                        onChange={(e) => setName(e.target.value)}
                        placeholder="John Doe" required size="sm" style={inputStyles.odSignerImputField}
                        type="text"
                        value={name}/>
                </Form.Group>

                <Form.Group>
                    <p className={styles.odSignerInputLabel}>
                        <FormattedMessage id={'labels.EMAIL'}/>
                        <span
                            aria-label="required field"
                            className="uxf-is-required">*</span>
                    </p>
                    <Form.Control className="odSignerImputField"
                        data-sl="mask"
                        id="odSignerEmail"
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="john.doe@example.com" required size="sm"
                        style={inputStyles.odSignerImputField}
                        type="email"
                        value={email}/>
                </Form.Group>

                <Form.Group>
                    <p className={styles.odSignerInputLabel}>
                        <FormattedMessage id={'labels.MOBILE'}/>
                        <span
                            aria-label="required field"
                            className="uxf-is-required">*</span>
                    </p>
                    <Form.Control className="odSignerImputField"
                        data-sl="mask"
                        id="odSignerContactNumber"
                        onChange={(e) => setContactNumber(e.target.value)}
                        placeholder="1111 2222 33" required size="sm" style={inputStyles.odSignerImputField}
                        type="text"
                        value={contactNumber}/>
                </Form.Group>
                {isProxy && (<Form.Group>

                    <p className={styles.odSignerInputLabel}>
                        <FormattedMessage id={'labels.THIRD_PARTY'}/>
                        <span
                            aria-label="required field"
                            className="uxf-is-required">*</span>
                    </p>
                    <Form.Control as="select"
                        className="odSignerImputField"

                        disabled={false}
                        id="odSignerThirdPartySelect"
                        onChange={handleThirdPartySelection}
                        style={inputStyles.odSignerImputField}
                        value={selectedThirdParty}

                    >

                        <option disabled value="">
                            {intl.formatMessage({id: 'labels.SELECT_THIRD_PARTY'})}
                        </option>
                        {filteredThirdParties.map((thirdParty, index) => (
                            <option key={index} value={`${thirdParty.tpNumber}-${thirdParty.role}`}>
                                {thirdParty.name} - {thirdParty.tpNumber}
                            </option>
                        ))}
                    </Form.Control>
                        {errorMessage && <p style={{ color: 'red', fontSize: '12px'}}>{errorMessage}</p>} {/* Display error message */}


                </Form.Group>

                )}
                <br/>
            </div>
            <Divider/>
            <DialogActions>

                {(name && email && contactNumber  && !errorMessage) ?
                    <Button disabled={false} onClick={() => saveAndAddNextOnDemandSigner()}
                        size="small" style={{backgroundColor: '#ffde00'}}
                        title={intl.formatMessage({id: 'labels.SAVE_&_ADD_NEXT_SIGNER'})}
                        variant="outlined">
                        <FormattedMessage id={'labels.ADD_NEXT'}/>
                    </Button>
                    : <Button disabled={true} onClick={() => saveAndAddNextOnDemandSigner()}
                            size="small" style={{backgroundColor: '#ffde00'}}
                            title={intl.formatMessage({id: 'labels.SAVE_SIGNER'})}
                            variant="outlined">
                        <FormattedMessage id={'labels.ADD_NEXT'}/>
                    </Button>
                }

                {(name && email && contactNumber  && !errorMessage) ?
                    <Button disabled={false} onClick={() => saveOnDemandSigner()}
                        size="small" style={{backgroundColor: '#ffde00'}}
                        title={intl.formatMessage({id: 'labels.ADD_SIGNER'})}
                        variant="outlined">
                        <FormattedMessage id={'labels.ADD'}/>
                    </Button>
                    : <Button disabled={true} onClick={() => saveOnDemandSigner()}
                            size="small" style={{backgroundColor: '#ffde00'}}
                            title={intl.formatMessage({id: 'labels.ADD_SIGNER'})}
                            variant="outlined">
                        <FormattedMessage id={'labels.ADD'}/>
                    </Button>
                }
            </DialogActions>
        </Dialog>
    )
}
